import React from 'react';
import { Container, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';
import { View } from '@uncinc/react-drupal-core';
import { TAXONOMY_TERM_HELP_TYPE_SUPPORTER } from '../../../config/constants';

const ParagraphHelpPagesSupporter = ({ entity }) => {
  const entityId = entity.get('target_id');
  const title = entity.getIn(['field_title', 0, 'value']);
  const body = entity.getIn(['field_body', 0, 'processed']);

  return (
    <Container className="ParagraphHelpPages">
      <div className="row">
        {title && (
          <div className="col-12">
            <h2 className="ParagraphHelpPages__title">{title}</h2>
          </div>
        )}
        <div className="ParagraphHelpPages__inner__content__body col-12">
          <WysiwygField
            property="schema:text"
            html={body}
            key={`paragraph:${entityId}`}
          />
        </div>
        <div className="col-12">
          <View id="related_help_pages" display="block_6" args={[TAXONOMY_TERM_HELP_TYPE_SUPPORTER]} />
        </div>
      </div>
    </Container>
  );
};

export default ParagraphHelpPagesSupporter;
